<template>
  <div class="jobs-container">
    <h3 class="section-title">加入禾苗</h3>
    <div class="jobs-intro">
      <p>禾苗（武汉）信息技术有限公司，致力于为母婴行业提供领先的数字化解决方案，我们的团队汇集了来自互联网、大数据、人工智能等领域的优秀人才。</p>
      <p>如果你热爱技术，对创新充满热情，欢迎加入我们，共同成长！</p>
      <p>Email：hr@hemiao100.com</p>
    </div>
    <div class="job-list">
      <div class="job-item" v-for="job in jobList" :key="job.id">
        <div class="job-header" @click="toggleJobDetail(job.id)">
          <h4 class="job-title">{{ job.title }}</h4>
          <span class="job-department">{{ job.department }}</span>
          <i :class="['expand-icon', { 'rotate': expandedJobId === job.id }]">▼</i>
        </div>
        <div v-if="expandedJobId === job.id" class="job-detail">
          <div class="detail-section">
            <h5>岗位职责：</h5>
            <ul class="clickable-list">
              <li v-for="(duty, index) in job.duties" :key="index" class="clickable-item" @click="onItemClick($event)">{{ duty }}</li>
            </ul>
          </div>
          <div class="detail-section">
            <h5>任职要求：</h5>
            <ul class="clickable-list">
              <li v-for="(requirement, index) in job.requirements" :key="index" class="clickable-item" @click="onItemClick($event)">{{ requirement }}</li>
            </ul>
          </div>
          <div class="apply-btn-container">
            <a href="mailto:hr@hemiao100.com" class="btn btn-primary apply-btn">立即申请</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutJobs',
  data() {
    return {
      activeTab: 'jobs',
      expandedJobId: null,
      jobList: [
        {
          id: 1,
          title: 'JAVA开发工程师',
          department: '技术部',
          duties: [
             '负责核心业务模块开发',
             '参与高并发系统架构设计，保障系统稳定性和数据准确性',
             '优化系统性能，提升用户使用体验',
             '与产品团队协作，将业务需求转化为技术方案'
          ],
          requirements: [
            '本科及以上学历，计算机相关专业',
            '3年以上Java开发经验，熟悉Spring、Spring Boot等框架',
            '对技术有热情，具备良好的业务理解能力和团队协作精神'
          ]
        },
        {
          id: 2,
          title: '产品经理',
          department: '产品部',
          duties: [
            '负责产品需求分析和规划',
            '制定产品路线图和迭代计划',
            '协调开发、设计、测试等团队资源',
            '持续优化产品体验，提升用户满意度'
          ],
          requirements: [
            '本科及以上学历，2年以上产品经理经验',
            '有SaaS产品或零售行业经验优先',
            '具备良好的数据分析能力，能通过数据驱动产品优化',
            '熟悉产品设计流程和方法论'
          ]
        },
        {
          id: 3,
          title: '销售经理',
          department: '销售部',
          duties: [
            '负责公司产品的市场推广和销售',
            '开拓新客户，维护老客户关系',
            '完成销售目标，参与商务谈判',
            '收集市场信息，分析竞争态势'
          ],
          requirements: [
            '本科及以上学历，2年以上SaaS或零售科技销售经验',
            '熟悉母婴、美妆或快消品行业，有品牌客户资源者优先',
            '具备解决方案销售能力，能理解客户导购激励业务痛点',
            '结果导向，具备良好的客户关系管理和商务谈判能力'
          ]
        }
      ]
    }
  },
  methods: {
    toggleJobDetail(jobId) {
      if (this.expandedJobId === jobId) {
        this.expandedJobId = null
      } else {
        this.expandedJobId = jobId
      }
    },
    onItemClick(event) {
      // 点击效果处理
      event.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
      setTimeout(() => {
        event.target.style.backgroundColor = '';
      }, 200);
    }
  }
}
</script>

<style scoped>
.jobs-container {
  padding: 20px;
}

.section-title {
  color: #333;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
}

.jobs-intro {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.jobs-intro p {
  line-height: 1.6;
  color: #555;
  margin-bottom: 10px;
}

.job-list {
  margin-top: 30px;
}

.job-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.job-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #007bff;
}

.job-header {
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #fafafa;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.job-header:hover {
  background-color: #f0f0f0;
}

.job-title {
  flex: 1;
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.job-department {
  color: #007bff;
  font-size: 14px;
  margin-right: 15px;
}

.expand-icon {
  color: #666;
  font-size: 12px;
  transition: transform 0.3s ease;
}

.expand-icon.rotate {
  transform: rotate(180deg);
}

.job-detail {
  padding: 20px;
  border-top: 1px solid #e0e0e0;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-section h5 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.detail-section ul.clickable-list {
  padding-left: 20px;
  margin: 0;
  background-color: #6badf317;
  border-radius: 4px;
  padding: 10px 20px;
}

.detail-section li.clickable-item {
  color: #686565;
  line-height: 1.6;
  margin-bottom: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 5px 10px;
  border-radius: 4px;
}

.detail-section li.clickable-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
  font-weight: 500;
}

.apply-btn-container {
  text-align: center;
  margin-top: 25px;
}

.apply-btn {
  padding: 10px 30px;
  font-size: 16px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

/* 展开收起的过渡动画 */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.expand-enter-to,
.expand-leave {
  opacity: 1;
  max-height: 1000px;
}

@media (max-width: 768px) {
  .jobs-container {
    padding: 15px;
  }
  
  .section-title {
    font-size: 24px;
  }
  
  .job-header {
    flex-wrap: wrap;
    padding: 15px;
  }
  
  .job-title {
    width: 100%;
    margin-bottom: 10px;
    font-size: 16px;
  }
  
  .job-detail {
    padding: 15px;
  }
  
  .apply-btn {
    padding: 8px 20px;
    font-size: 14px;
  }
}
</style>